import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { TaskStatusFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-find.dto';

import * as yup from 'yup';

/** BRS task status create/update request body - DTO signature */
export interface TaskStatusFormInterface {
  /** BRS task status display name */
  name?: string;
  /** BRS task status description name */
  description?: string;
  /** BRS task status color */
  color?: string;
  /** BRS task auditors */
  auditors?: UserFindInterface[];
  /** Parent BRS task */
  parent?: TaskStatusFindInterface;
}

/** BRS task status create/update request body - DTO schema */
export const TaskStatusFormDto = SerdeDtoClass.create<TaskStatusFormInterface>(TaskDtoKeysEnum.TASK_STATUS_FORM_DTO, {
  name: {
    optional: true,
    label: 'Название',
    serializer: yup.string(),
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: hexColorSchema,
  },
  auditors: {
    optional: true,
    label: 'Аудиторы',
    serializer: yup.array(entityLikeSchema),
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  parent: {
    optional: true,
    label: 'Над-статус',
    serializer: entityLikeSchema,
  },
});
